<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Oficina" resource="oficinas" primaryKey="idoficina" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import OficinaService from "@/services/oficina.service";
import { oficina } from "@/models/oficina";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: oficina,
      service: OficinaService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        OficinaService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
